<template>
  <modal-template size="small" :close="false">
    <div class="row">
      <div class="col-12 mB15 mT5">
        <h3 id="modal-error-title" class="mb-4">
          {{ $t("wegow.purchase.accessCode.title") }}
        </h3>
        <wegow-input
          id="access-code-event"
          v-model:value="accessCode"
          :placeholder="$t('wegow.purchase.accessCode.placeholder')"
          :focused="true"
          @enter="validate()"
        />
        <p v-if="error" class="error">
          {{ $t(error) }}
        </p>
        <br />
        <div class="flex justify-center space-x-2">
          <wegow-button
            :text="$t('general.accept')"
            size="xl"
            color="topaz-light"
            background="opacity"
            :disabled="accessCode === ''"
            @click="validate()"
          />
        </div>
      </div>
    </div>
  </modal-template>
</template>

<script setup>
import { usePurchase } from "@/composables/usePurchase";

import ModalTemplate from "@/components/general/modals/ModalTemplate.vue";
import WegowButton from "@/components/general/forms/WegowButton";
import WegowInput from "@/components/general/forms/WegowInput.vue";

import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const { validateAccessCode } = usePurchase();

const accessCode = ref("");
const error = ref("");
const route = useRoute();

const validate = async () => {
  let e = await validateAccessCode(accessCode.value);
  error.value = getAccessCodeErrorMessage(e);
};

onMounted(async () => {
  if (route.query.ac) {
    let e = await validateAccessCode(route.query.ac);
    accessCode.value = route.query.ac;
    error.value = getAccessCodeErrorMessage(e);
  }
});

const getAccessCodeErrorMessage = error => {
  if (error === "AccessCode not found") {
    return "wegow.purchase.accessCode.notfound";
  } else if (error === "AccessCode used") {
    return "wegow.purchase.accessCode.used";
  } else if (error === "AccessCode expired") {
    return "wegow.purchase.accessCode.expired";
  } else if (error === "AccessCode not active") {
    return "wegow.purchase.accessCode.notActive";
  } else if (error) {
    return "wegow.purchase.accessCode.nothandle";
  }
};
</script>
<style lang="scss" scoped>
.picture img {
  margin: auto;
}
#modal-error-title {
  margin-top: 10px;
  font-size: 25px !important;
  transition: all 1s ease-out;
  ~ p {
    margin-top: 6px;
  }
}
.error {
  color: $red;
}
</style>
